import React, { useState } from 'react'
import { Switch, Route, Link, useLocation } from 'react-router-dom'

import { usePet } from '../../modules'

import Receive from '../../components/reusable/receive'

import Home from './Home'
import Document from './Document'

const basePath = '/app/credit-patient-docs'

const CreditPatientDocs = () => {
    const [paths, setPaths] = useState([])

    const location = useLocation()
    const split = location.pathname.split('/')

    const [{ loading, error }] = usePet('singleSaleItem', { name: 'Credit Patient Docs' }, { notify: true, callback: ({ data }) => setPaths((data?.attached ?? []).map(doc => ({
        path: doc.name.toLowerCase().replace(' ', '-'),
        _id: doc._id,
        title: doc.name
    }))) })

    const page = split[3]

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <Receive
                progress
                loading={ loading }
                error={ error }>
                <div className="w-1/6 overflow-y-scroll">
                    <p className="text-2xl font-semibold">Credit Patient Documentation</p>
                    <ul className="space-y-2">
                        <li>
                            <Link to={basePath} className={ `flex items-center p-2 text-base font-normal text-gray-900 ${ !page ? 'text-yellow-600 border-l-4 border-yellow-500 h-8' : '' } hover:bg-gray-100` }>Home</Link>
                        </li>
                        {
                            paths.map(item =>
                                <li>
                                    <Link to={ `${basePath}/${item.path}` } className={ `flex items-center p-2 text-base font-normal text-gray-900 ${ page === item.path ? 'text-yellow-600 border-l-4 border-yellow-500 h-8' : '' } hover:bg-gray-100` }>{ item.title }</Link>
                                </li>
                            )
                        }
                    </ul>
                </div>
                <div className="w-5/6 overflow-y-scroll">
                    <Switch>
                        <Route exact path={basePath}>
                            <Home />
                        </Route>
                        {
                            paths.map(doc =>
                                <Route path={ `${basePath}/${doc.path}` }>
                                    <Document
                                        document={ doc }
                                        options={{ category: '' }} />
                                </Route>
                            )
                        }
                    </Switch>
                </div>
            </Receive>
        </div>
    )
}

export default CreditPatientDocs
